// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { fetchAndActivate, getRemoteConfig, getValue, activate } from "firebase/remote-config";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: "G-DV4D2H4EZK",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 5000;

export const requestForToken = (cb?: (token: string) => void) => {
	// The method getToken(): Promise<string> allows FCM to use the VAPID key credential
	// when sending message requests to different push services
	return getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY }) //to authorize send requests to supported web push services
		.then((currentToken) => {
			if (currentToken) {
				console.log("current token for client: ", currentToken);

				if (localStorage.getItem("fcmToken") && currentToken !== localStorage.getItem("fcmToken")) {
					localStorage.setItem("fcmToken", currentToken);
				} else if (!localStorage.getItem("fcmToken")) {
					localStorage.setItem("fcmToken", currentToken);
				}
				if (cb) {
					cb(currentToken);
				}
			} else {
				console.log("No registration token available. Request permission to generate one.");
			}
		})
		.catch((err) => {
			console.log("An error occurred while retrieving token. ", err);
		});
};

export const onMessageListener = () =>
	new Promise((resolve) => {
		onMessage(messaging, (payload) => {
			resolve(payload);
		});
	});

export { messaging, getToken, onMessage, remoteConfig, fetchAndActivate, getValue, activate };
